import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-new',
  template: require('./report-new.component.html')
})
export class ReportNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/report-new/report-new.component.ts